import React, { useEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import StartseiteBohren from '../pages/bohren/Startseite';
import StartseiteTragen from '../pages/tragen/Startseite';
import StartseiteZiehen from '../pages/ziehen/Startseite';
import ScreensaverBohren from '../pages/bohren/Screensaver';
import ScreensaverTragen from '../pages/tragen/Screensaver';
import ScreensaverZiehen from '../pages/ziehen/Screensaver';
import generateRoutes from './generateRoutes';
import HomePage from '../pages/Homepage';
import themes from '../themes';
import PageTransition from '../components/transitions/PageTransition';
import QuizLeicht from '../pages/quiz/QuizLeicht.jsx'
import QuizSchwer from '../pages/quiz/QuizSchwer.jsx'
import QuizSelection from '../pages/quiz/QuizStartseite.jsx'
import QuizScreenSaver from '../pages/quiz/QuizScreenSaver'

const AppRoutes = () => {
  const location = useLocation();
  const [dynamicRoutes, setDynamicRoutes] = useState([]);

  useEffect(() => {
    const loadRoutes = async () => {
      try {
        const routes = await generateRoutes();
        setDynamicRoutes(routes);
      } catch (error) {
        console.error('Fehler beim Laden der dynamischen Routen:', error);
      }
    };
    loadRoutes();
  }, []);

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        {/* Base Route */}
        <Route
          path={'/'}
          element={
            <PageTransition theme={themes}>
              <HomePage />
            </PageTransition>
          }
        />
        {/* Startseiten Routen */}
        <Route
          path={'/bohren/startseite'}
          element={
            <PageTransition theme={themes.bohren}>
              <StartseiteBohren />
            </PageTransition>
          }
        />
        <Route
          path={'/tragen/startseite'}
          element={
            <PageTransition theme={themes.tragen}>
              <StartseiteTragen />
            </PageTransition>
          }
        />
        <Route
          path={'/ziehen/startseite'}
          element={
            <PageTransition theme={themes.ziehen}>
              <StartseiteZiehen />
            </PageTransition>
          }
        />
        <Route
          path={'/quiz/startseite'}
          element={
            <PageTransition theme={themes.quiz}>
              <QuizSelection />
            </PageTransition>
          }
        />
        <Route
          path={'/quiz/quizLeicht'}
          element={
            <PageTransition theme={themes.quiz}>
              <QuizLeicht />
            </PageTransition>
          }
        />
        <Route
          path={'/quiz/quizSchwer'}
          element={
            <PageTransition theme={themes.quiz}>
              <QuizSchwer />
            </PageTransition>
          }
        />

        {/* Screensaver Routen */}
        <Route
          path={'/bohren'}
          element={
            <PageTransition theme={themes.bohren}>
              <ScreensaverBohren />
            </PageTransition>
          }
        />
        <Route
          path={'/tragen'}
          element={
            <PageTransition theme={themes.tragen}>
              <ScreensaverTragen />
            </PageTransition>
          }
        />
        <Route
          path={'/ziehen'}
          element={
            <PageTransition theme={themes.ziehen}>
              <ScreensaverZiehen />
            </PageTransition>
          }
        />
        <Route
          path={'/quiz'}
          element={
            <PageTransition theme={themes.quiz}>
              <QuizScreenSaver />
            </PageTransition>
          }
        />

        {/* Generierte Routen für Tastenseiten */}
        {dynamicRoutes.map((route, index) => (
          <React.Fragment key={index}>{route}</React.Fragment>
        ))}
      </Routes>
    </AnimatePresence>
  );
};

export default AppRoutes;
